import { QuestionTopChoices } from '../../../../entities/candidate_experience/QuestionTopChoices';
import { Col, Row } from 'reactstrap';
import {
  TopChoices,
  TopChoicesChartType,
} from '../../shared_panels/TopChoices';
import stylesheetExports from '../../../../stylesheets/export.module.scss';
import React from 'react';
import classNames from 'classnames';
import { REPORTING_SECTION_CLASS } from '../../../../utils/pdfHandler';
import { PageBreak } from '../PageBreak';

export function DropOffTopChoices(props: { dropOff: QuestionTopChoices }) {
  if (props.dropOff == null) return null;
  if (props.dropOff.top_choices.length === 0) return null;

  return (
    <>
      <PageBreak />
      <Row className={classNames(REPORTING_SECTION_CLASS)}>
        <Col xs='12'>
          <TopChoices
            title='Drop-off'
            subtitle={props.dropOff.question_text}
            topChoices={props.dropOff.top_choices}
            fillColor={stylesheetExports.chartOrange}
            type={TopChoicesChartType.Bar}
          />
        </Col>
      </Row>
    </>
  );
}
